import React, { useState } from "react";
import { DropdownOptions } from "../dropdownOptions";
import { Colors } from "../../Constants/colors";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";

interface Props {
  selectedOptions: DropdownOptions[] | null;
  onOptionRemoved: (removedOption: DropdownOptions) => unknown;
}

export const MultiSelectedOptions = ({
  selectedOptions,
  onOptionRemoved,
}: Props) => {
  const [hoveredChip, setHoveredChip] = useState<string | number | null>(null);

  return (
    <>
      <style>
        {`
          @keyframes chipFadeIn {
            from {
              opacity: 0;
              transform: scale(0.8);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          .chip-container {
            animation: chipFadeIn 0.2s ease-out;
          }

          .chip-remove-btn {
            transition: all 0.2s ease;
          }

          .chip-remove-btn:hover {
            transform: rotate(90deg) scale(1.2);
          }
        `}
      </style>
      <div
        className="flex flex-row flex-wrap gap-2 items-center"
        style={{ width: "92%", height: "100%", minHeight: "32px" }}
      >
        {!selectedOptions || selectedOptions.length === 0 ? (
          <div
            className="text-sm"
            style={{
              color: Colors.Midgrey,
              fontFamily: FontFamily.POPPINS_REGULAR,
              fontStyle: "italic",
              whiteSpace: "nowrap",
            }}
          >
            No options selected
          </div>
        ) : (
          (selectedOptions || []).map((option: DropdownOptions) => {
            const isHovered = hoveredChip === option.value;
            return (
              <div
                key={option.value}
                className="chip-container rounded-full flex content-center items-center"
                style={{
                  backgroundColor: isHovered
                    ? Colors.DarkOffWhite
                    : Colors.VeryLightGrey,
                  color: Colors.DarkGrey,
                  height: "26px",
                  paddingLeft: "10px",
                  paddingRight: "6px",
                  border: `1px solid ${isHovered ? Colors.LightGrey : Colors.LightAshRose}`,
                  boxShadow: isHovered
                    ? "0 2px 6px rgba(0, 0, 0, 0.1)"
                    : "0 1px 3px rgba(0, 0, 0, 0.06)",
                  cursor: "pointer",
                  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                  transform: isHovered ? "translateY(-1px)" : "translateY(0)",
                }}
                onMouseEnter={() => setHoveredChip(option.value)}
                onMouseLeave={() => setHoveredChip(null)}
              >
                <div
                  className="text-sm"
                  style={{
                    fontFamily: FontFamily.POPPINS_REGULAR,
                    marginRight: "6px",
                    whiteSpace: "nowrap",
                    fontSize: "13px",
                  }}
                >
                  {option?.text}
                </div>
                <div
                  className="chip-remove-btn"
                  onClick={(event: React.MouseEvent) => {
                    event.stopPropagation();
                    onOptionRemoved(option);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="12px"
                    height="12px"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </div>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};
